var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 3.33301H15.0002C15.4422 3.33301 15.8661 3.5086 16.1787 3.82116C16.4912 4.13372 16.6668 4.55765 16.6668 4.99967V16.6663C16.6668 17.1084 16.4912 17.5323 16.1787 17.8449C15.8661 18.1574 15.4422 18.333 15.0002 18.333H5.00016C4.55814 18.333 4.13421 18.1574 3.82165 17.8449C3.50909 17.5323 3.3335 17.1084 3.3335 16.6663V4.99967C3.3335 4.55765 3.50909 4.13372 3.82165 3.82116C4.13421 3.5086 4.55814 3.33301 5.00016 3.33301H6.66683",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 1.66699H7.49984C7.0396 1.66699 6.6665 2.04009 6.6665 2.50033V4.16699C6.6665 4.62723 7.0396 5.00033 7.49984 5.00033H12.4998C12.9601 5.00033 13.3332 4.62723 13.3332 4.16699V2.50033C13.3332 2.04009 12.9601 1.66699 12.4998 1.66699Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.d7d5e066b756f70f08b0db71f6a1bba6.svg";
export { ForwardRef as ReactComponent };